export default __webpack_public_path__ + "static/media/icons-16.2368f88a.eot";